import control from './control/control';
import local from './local/local';

const cmsControlInstance = control();
const cms = { ...local, ...cmsControlInstance };
export default cms;
